var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-header js-site-header"},[_c('iframe',{staticClass:"header-bar__iframe header-bar--sticky",attrs:{"id":"dn-header-iframe","src":_vm.standaloneHeaderUrl,"width":"100%","height":"97","scrolling":"no","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }